import "./VehiclesFiltersTools.scss";

import { useApplyFilters } from "../../../../../hooks/useApplyFilters";

import FilterAltOff from "@mui/icons-material/FilterAltOff";

import { TextButton } from "../../../../../common-components/Buttons/Buttons";

const VehiclesFiltersTools = () => {
    const componentId = "vehicles";
    const { clearFiltersParams } = useApplyFilters({componentId});

    return (
        <div className={"vehicles-filters-tools"}>
            <div className={"vehicles-filters-tools_container"}>
                <TextButton title={"Сбросить фильтры"} Icon={FilterAltOff} color={"#f44336"} active={true} onClick={clearFiltersParams}/>
            </div>
        </div>
    )
}

export default VehiclesFiltersTools;